import React from "react";
import Containertxt from "./Containertextone";
import Navbar from "./Navbar";




const Home = () => {
  return (
    <div className='home-container'>
    <Navbar />
    <Containertxt/>
    </div>
    )
}

export default Home